import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {fontWeights} from '../../libs/shared/ui/src/styles/fontStyles';
import {StyledTabElementsWrapper} from '../analytics/components/tabs/tabCommon';
import {settingsHorizontalPaddingStyles} from './settingsCommonConstants';

/*
 * Props.
 */

export interface SettingsHeaderProps {
  tabs?: ReactNode;
  right?: ReactNode;
  topLine?: ReactNode;
}

/*
 * Style.
 */

const StyledSettingsHeader = styled.div<{$hasTags: boolean}>`
  padding-top: 36px;
  ${settingsHorizontalPaddingStyles};

  position: relative;
  display: flex;
  flex-direction: column;

  ${(p) =>
    p.$hasTags &&
    css`
      border-bottom: 1px solid ${p.theme.greys.shade30};
      margin-bottom: 32px;
    `}
`;

const StyledSettingsHeaderContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const StyledSettingsHeaderTitle = styled.div`
  flex: 1;
  font-size: 24px;
  line-height: 31px;
  font-weight: ${fontWeights.black};
  color: ${(p) => p.theme.greys.shade90};
  margin: 0;

  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  grid-column-gap: 11px;
  align-items: center;
  grid-auto-columns: auto;
  overflow: hidden;
`;

const StyledSettingsHeaderToplineWrapper = styled.div`
  margin-bottom: 4px;
`;

/*
 * Component.
 */

export const SettingsHeader: FC<SettingsHeaderProps> = (props) => (
  <StyledSettingsHeader $hasTags={Boolean(props.tabs)}>
    {props.topLine && (
      <StyledSettingsHeaderToplineWrapper>{props.topLine}</StyledSettingsHeaderToplineWrapper>
    )}
    <StyledSettingsHeaderContent>
      <StyledSettingsHeaderTitle>{props.children}</StyledSettingsHeaderTitle>
      {props.right && <div>{props.right}</div>}
    </StyledSettingsHeaderContent>
    {props.tabs && <StyledTabElementsWrapper>{props.tabs}</StyledTabElementsWrapper>}
  </StyledSettingsHeader>
);
